import { FC } from 'react';

import { CommunicationInvalidRecipient } from 'types/Communication';

import TableRow from 'modules/_shared/Table/components/TableRow';
import { RowCell } from 'modules/_shared/Table/types/RowCell';

import { useTranslate } from 'hooks/useTranslate';
import { invalidEmailReasonsKeys } from 'modules/communications/constants/invalidEmailReasons';

type InvalidRecipientsTableRowProps = {
  index: number;
  invalidRecipient: CommunicationInvalidRecipient;
};

const InvalidRecipientsTableRow: FC<InvalidRecipientsTableRowProps> = ({
  index,
  invalidRecipient,
}) => {
  const { t } = useTranslate();

  const reasonLabelKey =
    invalidEmailReasonsKeys?.[
      invalidRecipient?.reason as keyof typeof invalidEmailReasonsKeys
    ];

  const cells = [
    {
      key: `invalid-email-${index}`,
      content: invalidRecipient.email,
    },
    {
      key: `invalid-name-${index}`,
      content: invalidRecipient.name,
    },

    {
      key: `reason-${index}`,
      content: t(reasonLabelKey),
    },
  ] as RowCell[];

  return <TableRow cells={cells} />;
};

export default InvalidRecipientsTableRow;
